const fontSizeConfig = [
  { id: 'xsmall', value: 11 },
  { id: 'small', value: 12 },
  { id: 'normal', value: 14 },
  { id: 'semilarge', value: 16 },
  { id: 'large', value: 20 },
  { id: 'larger', value: 32 },
  { id: 'xlarge', value: 48 },
  { id: 'xxlarge', value: 64 },
  { id: 'xxxlarge', value: 72 },
  { id: 'xxxxlarge', value: 96 },
];

const fontSizes = fontSizeConfig.reduce((fontSizesObj, fs, i) => {
  fontSizesObj[fs.id] = i;
  return fontSizesObj;
}, {});

const fontSizesValueList = fontSizeConfig.map(x => x.value);

export { fontSizes, fontSizesValueList };

export default fontSizes;
